import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsDragDropDirective } from './utils-drag-drop.directive';

@NgModule({
  declarations: [UtilsDragDropDirective],
  exports: [UtilsDragDropDirective],
  imports: [CommonModule]
})
export class UtilsDragDropModule {}
